import * as React from 'react';
import { useCallback, useState } from 'react';
import { AnyAction, compose, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { IStoreState } from '../../interfaces/State';
import { getHeaders } from '../../helpers/request/getHeaders';
import Button from 'lqa-ui/lib/Components/Button';
import Buttons from 'lqa-ui/lib/Components/Buttons';

import FrameLogin from 'lqa-ui/lib/Frames/Login'; 
import './EmailVerification.scss';
import FormRow from 'lqa-ui/lib/Components/FormRow';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import { ResponseStatusEnum } from '../../enums/ResponseStatus';

interface IProps extends RouteComponentProps {
    queries: any;
    token: string;
    location: any;
    match: any;
    history: any;
}

interface IState {
    isLoading: boolean;
    inputValue: string;
    message: string;
    newPasswordValue: string;
    confirmPasswordValue: string;
    useNewPassword: boolean;
    mailVerification: boolean;
    hasError: boolean;
    isUpdatePasswordPending: boolean;
    token: string;
    newPasswordConstraints: {
        hasLength: boolean;
        hasNumber: boolean;
        hasSpecialChar: boolean;
        isMatch: boolean;
        isConstraintsPassed: boolean;
    };
}

interface IDispatchProps {
}

class EmailVerification extends React.Component<IProps, IState> {
    readonly state: IState = {
        isLoading: false,
        inputValue: '',
        message: 'Email verification started ...',
        newPasswordValue: '',
        confirmPasswordValue: '',
        useNewPassword: false,
        mailVerification: false,
        hasError: false,
        isUpdatePasswordPending: false,
        token: '',
        newPasswordConstraints: {
                hasLength: false,
                hasNumber: false,
                hasSpecialChar: false,
                isMatch: false,
                isConstraintsPassed: false,
            },
    };

    constructor(props) {
        super(props);
    }
    
    validateNewPassword = (newPasswordValue, confirmPasswordValue) => {
        const obj = {
            hasLength: false,
            hasNumber: false,
            hasSpecialChar: false,
            isMatch: false,
            isConstraintsPassed: false,
        };
        // Check Password Length
        if (newPasswordValue.length >= 8) {
            obj.hasLength = true;
        }
        // Check if Password has number
        if (newPasswordValue.match(/\d+/) !== null) {
            obj.hasNumber = true;
        }
        // Check if Password has special character
        if (newPasswordValue.search(/[!#$%&?@^*]/g) > 0) {
            obj.hasSpecialChar = true;
        }
        // Check if Password does match with confirmPassword
        if (newPasswordValue.length > 0 && confirmPasswordValue.length > 0 && newPasswordValue === confirmPasswordValue) {
            obj.isMatch = true;
        }
        if (obj.hasLength && obj.hasNumber && obj.hasSpecialChar && obj.isMatch) {
            obj.isConstraintsPassed = true;
            this.setState({hasError: false});
        } else {
            obj.isConstraintsPassed = false;
            this.setState({hasError: true});
        }
        this.setState({newPasswordConstraints: obj});
    };
        
    updatePassword = async (token, password) => {
        // Prepare API URL
        const API = `${Env.API_URL}/auth/updatePassword`;
        this.setState({ isLoading: true });
        try {
            const res = await fetch(API, {
                method: 'PUT',
                headers: getHeaders(),
                body: JSON.stringify({ token, password }),
            });
            let response;
            if (res) {
                response = await res.json();
                this.setState({ useNewPassword: false });
                this.setState({mailVerification: true});
                this.setState({ isLoading: false });
                this.setState({ isLoading: false, message: response.message });
                
            }
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };
    
    /**
     * Fetch HeatAutoPopulate list from API
     */
    callVerificationAPI = async (token) => {

        // Prepare API URL
        const API = `${Env.API_URL}/auth/verifyEmail`;
        this.setState({ isLoading: true });
        try {
            const res = await fetch(API, {
                method: 'PUT',
                headers: getHeaders(),
                body: JSON.stringify({ token }),
            });
            let response;
            if (res) {
                response = await res.json();
                if (res.status === ResponseStatusEnum.ok) {
                    this.setState({ useNewPassword: true });
                    this.setState({token: response.token});
                    this.setState({mailVerification: false});
                    this.setState({ isLoading: false});
                } else {
                    this.setState({mailVerification: true});
                    this.setState({ useNewPassword: false });
                    this.setState({ isLoading: false, message: response.message });
                }
            }
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    componentDidMount() {
        if (this.props && this.props.token) {
            this.callVerificationAPI(this.props.token);
        }
    }

    render() {
        
        return (
            <FrameLogin title="LQA">
                <div>
                    {(
                        <React.Fragment>
                            <div className="login-main">
                                
                                {
                                    this.state.useNewPassword ? (
                                        <div className="inner">
                                            <div className="use-current-mail">
                                                <div className="password-screen-content">
                                                    Your email is successfully validated. 
                                                    We're also increasing our requirements for Password security.
                                                    Password must now have:
                                            </div>
                                                <div className="password-screen-content">
                                                    <div className={this.state.newPasswordConstraints.hasLength ? 'label-success' : 'label-error'}>
                                                        - 8 characters
                                                    </div>
                                                    <div className={this.state.newPasswordConstraints.hasNumber ? 
                                                        'label-success' : 'label-error'}>
                                                        - At least one number
                                                    </div>
                                                    <div className={this.state.newPasswordConstraints.hasSpecialChar ? 
                                                        
                                                        'label-success' : 'label-error'}>
                                                        - At least one special character
                                                    </div>
                                                    <div className={this.state.newPasswordConstraints.isMatch ? 'label-success' : 'label-error'}>
                                                        - Passwords Must Match
                                                    </div>
                                                </div>
                                                <div>
                                                    <FormRow label={'New Password:'}>
                                                        <ControlInput
                                                            errorAnimated={true}
                                                            secureTextEntry={true}
                                                            hasError={this.state.hasError}
                                                            value={this.state.newPasswordValue}
                                                            autoFocus={true}
                                                            onChange={async (event) => {
                                                                if (this.state.hasError) {
                                                                    this.setState({hasError: false});
                                                                }
                                                                await this.setState({newPasswordValue: event.target.value});
                                                                this.validateNewPassword(this.state.newPasswordValue, 
                                                                    this.state.confirmPasswordValue);
                                                            }}
                                                        />
                                                    </FormRow>
                                                </div>
                                                <div>
                                                    <FormRow label={'Confirm Password:'}>
                                                        <ControlInput
                                                            errorAnimated={true}
                                                            secureTextEntry={true}
                                                            hasError={this.state.hasError}
                                                            value={this.state.confirmPasswordValue}
                                                            onChange={async (event) => {
                                                                if (this.state.hasError) {
                                                                    this.setState({hasError: false});
                                                                }
                                                                await this.setState({confirmPasswordValue: event.target.value});
                                                                this.validateNewPassword(this.state.newPasswordValue, 
                                                                    this.state.confirmPasswordValue);
                                                            }}
                                                        />
                                                    </FormRow>
                                                </div>
                                                <Buttons layout="vertical-wide">
                                                    <Button
                                                        onClick={() => {
                                                            this.updatePassword(this.state.token, this.state.newPasswordValue);
                                                        }}
                                                        title={'Continue'}
                                                        disabled={this.state.newPasswordConstraints.isConstraintsPassed === false}
                                                        loading={this.state.isUpdatePasswordPending}
                                                        intent="primary"
                                                    />
                                                </Buttons>
                                            </div>
                                        </div>
                                    ) : ''
                                }
                                {
                                    this.state.mailVerification ? (
                                        <div className="inner">
                                            <div className="email-verification-ui">
                                                {(
                                                    <React.Fragment>
                                                        <div className="login-main">
                                                            <div className="inner">
                                                                <h1>{this.state.message}</h1>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            <div>
                                                <Buttons layout="vertical-wide">
                                                    <Button
                                                        onClick={() => {
                                                            window.location.href = window.location.origin + '/';
                                                        }}
                                                        title="Go To Login"
                                                        intent="primary"
                                                    />
                                                </Buttons>
                                            </div>
                                        </div>
                                    ) : ''
                                }
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </FrameLogin>
        );
    }
}

const mapStateToProps = (state: IStoreState) => {
    return {
        queries: state.queries,
    };
};
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): {} => {
    return {
    };
};

export default compose<React.ComponentClass<IProps>>(
    withRouter,
    connect<IStoreState, IDispatchProps, IProps>(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })
)(EmailVerification);
